import type { IPaginatedResponse, IPagination } from '../../types';
import type {
	TalkingHeadActorEventIdn,
	TalkingHeadArgument,
	TalkingHeadCommandIdn
} from '../TalkingHeadService/types';

export enum ConversationTurnType {
	Messages = 'messages',
	Events = 'events',
	Custom = 'custom'
}

export enum SkillIdn {
	InputResponse = 'input_response'
}

export enum SystemConnectorIdn {
	System = 'system/system',
	ThoughtsFootnote = 'system/thoughts_footnote',
	SystemFootnote = 'system/system_footnote'
}

export enum ConversationActsPaginationType {
	Cursor = 'cursor'
}

export type ConversationActsParams = {
	user_actor_id?: string;
	user_actor_ids?: string;
	reference_idns?: NonNullable<ConversationAct['reference_idn']>[];
	page?: number;
	per?: number;
};

export type BffConversationFilters = {
	turn_type?: ConversationTurnType;
	event_idns?: NonNullable<ConversationAct['reference_idn']>[];
	from_datetime?: string;
	to_datetime?: string;
	connectors?: string[];
	agent_persona_id?: string;
	query?: string;
	session_id?: string;
};

export type BffConversationActsFilters = BffConversationFilters & {
	user_persona_id?: string;
	user_actor_id?: string;
};

export type BffConversationActsParams = BffConversationActsFilters & {
	before?: string;
};

export type ConversationRecording = {
	id: string;
	duration: number;
	file_size: number;
	play_url: string;
};

export type ConversationAct = {
	id: string;
	command_act_id?: string | null;
	external_event_id?: string | null;
	arguments?: TalkingHeadArgument[];
	reference_idn?: TalkingHeadActorEventIdn | TalkingHeadCommandIdn | null;
	runtime_context_id?: string | null;
	source_text?: string | null;
	original_text?: string | null;
	english_text?: string | null;
	datetime: string;
	user_actor_id?: string | null;
	contact_information?: string | null;
	agent_actor_id?: string | null;
	user_persona_id?: string | null;
	user_persona_name?: string | null;
	agent_persona_id?: string | null;
	external_id?: string | null;
	integration_idn?: string | null;
	connector_idn?: string | null;
	to_integration_idn?: string | null;
	to_connector_idn?: string | null;
	is_agent?: boolean;
	project_idn?: string | null;
	flow_idn?: string | null;
	skill_idn?: string | null;
	session_id?: string | null;
	recordings?: ConversationRecording[];
};

export type ConversationActsResponse = {
	items?: ConversationAct[];
	metadata?: IPagination;
};

export type BffConversationUserPersonasParams = BffConversationFilters & {
	skip_without_user_messages?: boolean;
	hide_not_found?: boolean;
	page: number;
	per: number;
};

export type ConversationUserPersonaActor = {
	id: string;
	conversation_is_active: boolean;
	act_count: number;
	external_id: string;
	integration_idn: string;
	connector_idn: string;
	contact_information: string;
};

export type ConversationUserPersona = {
	id: string;
	name: string | null;
	last_act_time: string;
	last_act_text: string | null;
	last_session_id: string | null;
	act_count: number;
	not_found: boolean;
	session_is_active: boolean;
	actors: ConversationUserPersonaActor[];
};

export type BffConversationActsResponse = {
	items: ConversationAct[];
	metadata: {
		before: string | null;
	};
};

export type BffConversationUserPersonasResponse =
	IPaginatedResponse<ConversationUserPersona>;
